export default logoutCtrl

/** @ngInject */
function logoutCtrl(LogoutService, LogNavigation, PermPermissionStore, $window, $state) {
    return PermPermissionStore.getStore().user.validatePermission()
    .then(() => LogNavigation.log({ url: $state.current.url }).$promise)
    .then(() => LogoutService.logout())
    .finally((err) => {
        $window.location.href = `https://${$window.location.host}`
    })
}



// WEBPACK FOOTER //
// ./src/states/logout/controller.js